The details of the conflicting candidate.

The conflicting candidate profile is available in the `profiles` field.
